// Pops a few tiny glass-colored sparkles wherever a visitor clicks.
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const colors = ['#F29A5B', '#F4B66A', '#E07A8A', '#EEE9C1', '#DDA53A', '#6F9A88'];
  const path = 'M12 0c1 7 4 10.2 12 12-8 1.8-11 5-12 12-1-7-4-10.2-12-12 8-1.8 11-5 12-12z';

  document.addEventListener('pointerdown', (event) => {
    for (let i = 0; i < 5; i++) {
      const size = 8 + Math.random() * 10;
      const angle = (Math.PI * 2 * i) / 5 + Math.random() * 0.6;
      const distance = 24 + Math.random() * 26;
      const el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      el.setAttribute('viewBox', '0 0 24 24');
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = `<path d="${path}" fill="${colors[(Math.random() * colors.length) | 0]}" stroke="#2E2A33" stroke-width="1.5"/>`;
      Object.assign(el.style, {
        position: 'fixed',
        left: `${event.clientX - size / 2}px`,
        top: `${event.clientY - size / 2}px`,
        width: `${size}px`,
        height: `${size}px`,
        pointerEvents: 'none',
        filter: 'drop-shadow(0 0 4px rgb(242 140 90 / 0.8))',
        zIndex: 9999,
      });
      document.body.appendChild(el);
      el.animate(
        [
          { transform: 'translate(0, 0) scale(0.4) rotate(0deg)', opacity: 1 },
          {
            transform: `translate(${Math.cos(angle) * distance}px, ${Math.sin(angle) * distance}px) scale(1) rotate(90deg)`,
            opacity: 0,
          },
        ],
        { duration: 650 + Math.random() * 250, easing: 'cubic-bezier(.2,.7,.3,1)' }
      ).onfinish = () => el.remove();
    }
  });
})();
